<template>
  <div class="form">
    <h1>Na pewno chcesz usunąć wiadomość?</h1>
    <button class="delete-btn" @click.prevent="deleteDirect(deletedDirectId)">Usuń</button>
    <button class="cancel-btn" @click.prevent="isDirectDeleteModal = false">Anuluj</button>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
